var $bc4df9725b06a282$exports = {};
$bc4df9725b06a282$exports = {
    "replaceMessage": `Rilascia il file da sostituire`
};


export {$bc4df9725b06a282$exports as default};
//# sourceMappingURL=it-IT.mjs.map
